var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessagesSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.565,
    height: 22.924,
    viewBox: "0 0 30.565 22.924",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "envelope-solid",
    d: "M2.866,64a2.866,2.866,0,0,0-1.719,5.158L14.137,78.9a1.916,1.916,0,0,0,2.292,0l12.99-9.743A2.866,2.866,0,0,0,27.7,64ZM0,70.686V83.1a3.824,3.824,0,0,0,3.821,3.821H26.745A3.824,3.824,0,0,0,30.566,83.1V70.686l-12.99,9.743a3.815,3.815,0,0,1-4.585,0Z",
    transform: "translate(0 -64)",
    fill: "#154157"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagesSolid);
export default __webpack_public_path__ + "static/media/messages-solid.8a96e177b7bfdd85914726b659b1e73a.svg";
export { ForwardRef as ReactComponent };